/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-09-03 10:04.
 */
const info = '<p class="first">乌海市公共资源交易中心网“公共信箱”</p> <p class="second">是乌海市公共资源交易中心面向社会公众设立的专用电子信箱。您的来信我们将按程序予以办理，并在一定时限内向您反馈处理结果。</p>';
class wuhaiMail {
  constructor () {
    this.imgTitle = $('.img-info');
    this.init();
  }
  init () {
    let here = this;
    here.imgTitle.html(info);
  }
}


module.exports = wuhaiMail;
